import React from 'react';
import PeopleGroupIcon from '@atlaskit/icon/core/people-group';
import type { UserOption } from '@atlassian/jira-base-user-picker/src/types.tsx';
import MultiUserPickerField from '@atlassian/jira-issue-create-commons/src/ui/multi-userpicker-field/index.tsx';
import { MULTI_USER_CF_TYPE } from '@atlassian/jira-platform-field-config/src/index.tsx';
import { AssigneeFieldPlaceholder } from '../../../ui/field-placeholders/index.tsx';
import type { FieldTypeConfig } from '../types.tsx';
import { multiUserPickerFieldWriter } from '../writers/index.tsx';

export const MultiUserCustomFieldTypeConfig: FieldTypeConfig<UserOption[]> = {
	icon: PeopleGroupIcon,
	type: MULTI_USER_CF_TYPE,
	Component: MultiUserPickerField,
	placeholder: <AssigneeFieldPlaceholder />,
	writer: multiUserPickerFieldWriter,
};
